import { Type } from 'class-transformer';

export class ActionMenuInfo {
    action: string;
    name: string;
    icon?: string;
    separator?: boolean;
    disabled?: boolean;
    securityIndicator?: 'KEY' | 'LOCK' | 'SHIELD';
    apiAction?: 'POST' | 'PUT' | 'DELETE';
    apiUrl?: string;
    parent?: string;
    info?: any;

    @Type(() => ActionMenuInfo)
    items?: Array<ActionMenuInfo>;
}

export class ActionMenuEvent<T> {
    item: ActionMenuInfo;
    action: string;
    record: T;
    rowIndex: number;
    elementId?: string;
}
